import React from 'react';
import { Descriptions, Typography, List, Space, Layout } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/es';

const { Title } = Typography;
const { Content } = Layout;

export default function ValidationEmailHistory({
  validationData = {},
  dataSource = [],
  key = 'validation-email-history',
}) {
  return (
    <Space direction={'vertical'} style={{ width: '100%' }}>
      <Descriptions layout="vertical" column={2} bordered>
        <Descriptions.Item label="Proyecto a revisar">
          {validationData.nombre_proyecto}
        </Descriptions.Item>
        <Descriptions.Item label="Cargo/rol a revisar">
          {validationData.cargo}
        </Descriptions.Item>
        <Descriptions.Item label="Nombre completo/Razón social">
          {validationData.nombres_apellidos}
        </Descriptions.Item>
        <Descriptions.Item label="Tipo y número de documento">
          {validationData.identificacion}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions column={1} bordered layout="vertical">
        <Descriptions.Item key={key} label="Notificación">
          <List
            dataSource={dataSource}
            grid={{ gutter: [0, 24], column: 1 }}
            renderItem={(item, index) => (
              <Content>
                <Title level={5}>
                  Email No. {index + 1} - Enviado el:{' '}
                  {dayjs(item.created_at).format('DD MMMM YYYY h:mm a')}
                </Title>
                <div
                  key={`${key}-${index}`}
                  dangerouslySetInnerHTML={{ __html: item.mensaje }}
                />
              </Content>
            )}
            pagination={false}
          />
        </Descriptions.Item>
      </Descriptions>
    </Space>
  );
}
